import SubLabel from "components/Atoms/Sublabel";
import { VenueSidePanel } from "components/SidePanel/Venue/VenueSidePanel";
import React from "react";
import { RemovableLabel, RemovableProps } from "./Removable";

const RemovableVenue = (props: RemovableProps<server.dto.VenueSmall>) => {
  return <RemovableLabel {...props}>
    <div>
      <VenueSidePanel
        venueId={props.value.venueId}
        trigger={<a>{props.value.name}</a>}
      />
      <SubLabel>{props.value.cityCountry}</SubLabel>
    </div>
  </RemovableLabel>
};

export default RemovableVenue;